// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"4ec2acfc","38":"4ec2acfc","112":"4ec2acfc","231":"4ec2acfc","313":"4ec2acfc","388":"4ec2acfc","403":"4ec2acfc","524":"4ec2acfc","608":"4ec2acfc","882":"4ec2acfc"}[chunkId] + ".chunk.css";
};